import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';


export default function withServices(ComposedComponent) {
  const klass = class extends PureComponent {
    public static contextTypes = {
      services: PropTypes.object,
    }

    constructor(props) {
      super(props);
    }

    public render() {
      return <ComposedComponent services={this.context.services} {...this.props} />
    }
  };

  return klass;
}



// WEBPACK FOOTER //
// ./src/HOCs/withServices.tsx